import React from "react";
import styles from "./FestiveSection.module.css";

const dataCards = [
  {
    title: "Sarhul Celebration",
    description:
      "Experience the vibrant tribal New Year marked by nature worship, traditional dances, and community joy.",
    image: "/images/Sarhul/sarhul7.jpeg",
  },
  {
    title: "Sacred Grove Rituals",
    description:
      "Witness the offering of sal flowers to Mother Earth, symbolizing gratitude and a bountiful year ahead.",
    image: "/images/Sarhul/sarhul6.jpeg",
  },
  {
    title: "Cultural Gathering",
    description:
      "Join in the rhythmic tribal dances, music, and celebrations that echo the spirit of Sarhul.",
    image: "/images/Sarhul/sarhul4.jpeg",
  },
];

const DataCard = ({ title, description, image }) => (
  <div className={styles.card} style={{ backgroundImage: `url(${image})` }}>
    <div className={styles.overlay}></div>
    <div className={styles.cardContent}>
      <h3 className={styles.cardTitle}>{title}</h3>
      <p className={styles.cardDescription}>{description}</p>
    </div>
  </div>
);

const FestiveSection = () => {
  return (
    <section className={styles.container}>
      {/* Header */}
      <div className="text-center mb-5">
        <h2 className="fw-bold">Sarhul Festival</h2>
        <p className="text-muted">Celebrating Nature, Culture & Community</p>
      </div>

      <div className={styles.cardsContainer}>
        {dataCards.map((card, index) => (
          <DataCard key={index} {...card} />
        ))}
      </div>
      <div className="container py-4">
        <div>

          <p className="mb-3">
            <strong>Sarhul 2026</strong>, the vibrant festival marking the tribal New Year, was celebrated across Jharkhand with immense devotion, cultural pride, and community participation. Rooted in nature worship, the festival reflects the deep spiritual connection of tribal communities with forests, land, and the changing seasons.
          </p>

          <p className="mb-3">
            Across districts, <strong>Sarna Sthals</strong> became focal points of rituals where devotees offered sacred <strong>sal flowers</strong> to Mother Earth, seeking blessings for prosperity, harmony, and a fruitful year ahead. The celebrations echoed with rhythmic folk music, traditional dances, and rituals that have been preserved through generations.
          </p>

          <p className="mb-0">
            Celebrated collectively across the state, <strong>Sarhul 2026</strong> stood as a powerful expression of unity, identity, and cultural pride — positioning Jharkhand as a land where traditions are not just preserved, but truly lived.
          </p>

        </div>
      </div>
    </section>
  );
};

export default FestiveSection;
